(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homeward-balanced"] && !Shopify.designMode) return;
  try {
    
  function updateHomewardCarousel(section) {
    const track = section.querySelector('[data-hb-track]');
    if (!track) return;
    const previous = section.querySelector('[data-hb-prev]');
    const next = section.querySelector('[data-hb-next]');
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.hb-carousel-control');
    if (!button) return;
    const section = button.closest('.hb-spaces, .hb-products, .hb-review, .hb-room');
    const track = section?.querySelector('[data-hb-track]');
    const first = track?.firstElementChild;
    if (!track || !first) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const direction = button.hasAttribute('data-hb-prev') ? -1 : 1;
    track.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  document.addEventListener('scroll', (event) => {
    if (event.target.matches?.('.hb-track')) updateHomewardCarousel(event.target.closest('section'));
  }, true);

  function initHomewardCarousels() {
    document.querySelectorAll('.hb-spaces, .hb-products, .hb-review, .hb-room').forEach(updateHomewardCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomewardCarousels);
  else initHomewardCarousels();
  window.addEventListener('resize', initHomewardCarousels);
  document.addEventListener('shopify:section:load', initHomewardCarousels);

  let homewardRoomShapeFrame = 0;
  function updateHomewardRoomShapes() {
    homewardRoomShapeFrame = 0;
    document.querySelectorAll('[data-hb-room-shape]').forEach((atmosphere) => {
      const room = atmosphere.closest('.hb-room');
      if (!room || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const bounds = room.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (window.innerHeight * 0.5 - (bounds.top + bounds.height * 0.5)) / (window.innerHeight + bounds.height)));
      atmosphere.style.setProperty('--hb-room-drift-x', (progress * -34).toFixed(2) + 'px');
      atmosphere.style.setProperty('--hb-room-drift-y', (progress * 78).toFixed(2) + 'px');
    });
  }
  function queueHomewardRoomShapes() {
    if (!homewardRoomShapeFrame) homewardRoomShapeFrame = window.requestAnimationFrame(updateHomewardRoomShapes);
  }
  window.addEventListener('scroll', queueHomewardRoomShapes, { passive: true });
  window.addEventListener('resize', queueHomewardRoomShapes, { passive: true });
  document.addEventListener('shopify:section:load', queueHomewardRoomShapes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueHomewardRoomShapes);
  else queueHomewardRoomShapes();

  const homewardParallaxMedia = window.matchMedia('(prefers-reduced-motion: no-preference)');
  let homewardParallaxFrame = 0;
  function updateHomewardParallax() {
    homewardParallaxFrame = 0;
    document.querySelectorAll('.hb-hero[data-hb-parallax="true"]').forEach((hero) => {
      const active = homewardParallaxMedia.matches && !!hero.querySelector(':scope > img');
      hero.classList.toggle('hb-parallax-active', active);
      if (!active) {
        hero.style.removeProperty('--hb-parallax-y');
        return;
      }
      const bounds = hero.getBoundingClientRect();
      const mobile = window.innerWidth < 990;
      const distance = Math.max(0, Math.min(-bounds.top * (mobile ? 0.09 : 0.12), bounds.height * (mobile ? 0.055 : 0.085), mobile ? 34 : 60));
      hero.style.setProperty('--hb-parallax-y', distance.toFixed(2) + 'px');
    });
  }
  function queueHomewardParallax() {
    if (!homewardParallaxFrame) homewardParallaxFrame = window.requestAnimationFrame(updateHomewardParallax);
  }
  window.addEventListener('scroll', queueHomewardParallax, { passive: true });
  window.addEventListener('resize', queueHomewardParallax, { passive: true });
  window.addEventListener('pageshow', queueHomewardParallax);
  homewardParallaxMedia.addEventListener('change', queueHomewardParallax);
  document.addEventListener('shopify:section:load', queueHomewardParallax);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueHomewardParallax);
  else queueHomewardParallax();

  if (!customElements.get('homeward-sound-wave')) {
    customElements.define('homeward-sound-wave', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-wave-visible') || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.setAttribute('data-wave-ready', '');
        this.waveObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.setAttribute('data-wave-visible', '');
            this.waveObserver.disconnect();
          }
        }, { threshold: 0.7 });
        this.waveObserver.observe(this);
      }
      disconnectedCallback() {
        this.waveObserver?.disconnect();
      }
    });
  }

  const homewardRevealObservers = new Map();
  function initHomewardReveals() {
    homewardRevealObservers.forEach((observer, root) => {
      if (!root.isConnected) {
        observer.disconnect();
        homewardRevealObservers.delete(root);
      }
    });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-hb-reveals="true"]').forEach((root) => {
      if (homewardRevealObservers.has(root)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-hb-reveal', 'shown');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold:0.08 });
      homewardRevealObservers.set(root, observer);
      root.querySelectorAll('.hb-intro > h2, .hb-intro > p:not(.hb-eyebrow), .hb-intro-benefits, .hb-section-head, .hb-room-copy, .hb-material-copy, .hb-flex-copy, .hb-last > div').forEach((element) => {
        element.setAttribute('data-hb-reveal', 'pending');
        const bounds = element.getBoundingClientRect();
        const visible = bounds.top < window.innerHeight && bounds.bottom > 0 && bounds.left < window.innerWidth && bounds.right > 0;
        if (visible) {
          window.requestAnimationFrame(() => element.setAttribute('data-hb-reveal', 'shown'));
        } else {
          observer.observe(element);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomewardReveals);
  else initHomewardReveals();
  document.addEventListener('shopify:section:load', initHomewardReveals);
  document.addEventListener('shopify:section:unload', initHomewardReveals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
